import {
  hidePhoneEmail
} from '@/utils/utils'

const fn = {}
fn.install = function (Vue, options = {}) {
  Vue.prototype.$fn = {
    hidePhoneEmail
  }
}
export default fn